import { UrlMatcher, UrlSegment } from '@angular/router';
import { STANDARD_REMOTE_URL_PREFIX } from '../consts';

export function isUrlOfStandardRemoteApplication(): UrlMatcher {
	return (url: UrlSegment[]) => {
		if (url[0]?.path === STANDARD_REMOTE_URL_PREFIX) {
			return { consumed: url };
		}
		return null;
	};
}
